let _ = require('lodash');
let utils = require('../utils');
const basePath = ['order', 'addParams', 'numberOfFilials'];

module.exports = {
    initOptions ({ availableParameters }, state) {
        const numberOfFilials = availableParameters.numberOfFilials;
        const columns = availableParameters.exportColumns ? availableParameters.exportColumns.columns : [];
        const filialsExportColumn = _.find(columns, (x) => x.propertyName === 'NumberOfFilials');

        if (filialsExportColumn && numberOfFilials) {
            state.set(['order', 'addParams', 'numberOfFilials', 'options'],
                _.map(Object.keys(numberOfFilials),
                    (key) => ({ isActive: key === '-1', title: numberOfFilials[key], value: key })));
            state.set(['order', 'addParams', 'numberOfFilials', 'isDisable'], false);
            state.set(['order', 'addParams', 'numberOfFilials', 'isOpen'], false);
            // привязываем popup
            utils.setPopupVisibility('numberOfFilialsPopup', ['order', 'addParams', 'numberOfFilials', 'isOpen'])
            ({}, state);
        }
    },

    selectFilialsNumber ({ selectedValue }, state) {
        let options = state.get(basePath.concat('options'));
        let oldSelectedValueIndex = _.findIndex(options, { isActive: true });
        if (oldSelectedValueIndex > -1) {
            state.set(basePath.concat(['options', oldSelectedValueIndex, 'isActive']), false);
        }
        let selectedIndex = _.findIndex(options, { value: selectedValue });
        if (selectedIndex > -1) {
            state.set(basePath.concat(['options', selectedIndex, 'isActive']), true);
        }
    }
};



// WEBPACK FOOTER //
// ./actions/custom-order/filials.js